export function updateExplosions(roundData, currentTick, previousTick, getConvertedCords, pixelsPerMapUnit, frameRate, svgWidth, existingExplosions = []) {
  if (!roundData || !roundData.grenades) return [];

  const explosionDurationTicks = 3;
  const activeExplosions = [];
  const processedGrenadeIds = new Set();
  const ppu = pixelsPerMapUnit || 1;
  const EXPLOSION_BASE_RADIUS_U = 17;

  roundData.grenades.forEach((grenade) => {
    const { destroyTick } = grenade;
    const grenadeType = grenade.grenadeType?.toLowerCase() || '';
    const isHE = grenadeType.includes('hegrenade');
    const isFlash = grenadeType.includes('flashbang');

    if (!destroyTick || (!isHE && !isFlash)) return;

    const explosionId = `explosion-${grenade.uniqueID}`;
    const isInExplosionWindow = currentTick >= destroyTick && currentTick < destroyTick + explosionDurationTicks;
    const steppedOverWindow = previousTick < destroyTick && currentTick >= destroyTick + explosionDurationTicks;

    if (isInExplosionWindow || steppedOverWindow) {
      processedGrenadeIds.add(grenade.uniqueID);

      let existingExplosion = existingExplosions.find((e) => e.id === explosionId);

      if (!existingExplosion) {
        let explosionX = grenade.grenadeX;
        let explosionY = grenade.grenadeY;

        if (grenade.vectors && grenade.vectors.length > 0) {
          const lastVector = grenade.vectors[grenade.vectors.length - 1];
          if (lastVector.x !== undefined && lastVector.y !== undefined) {
            explosionX = lastVector.x;
            explosionY = lastVector.y;
          }
        }

        const cords = getConvertedCords(explosionX, explosionY);
        if (!cords) return;

        const color = isHE ? 'orange' : 'white';
        const baseRadius = EXPLOSION_BASE_RADIUS_U * ppu;

        existingExplosion = {
          id: explosionId,
          x: cords.x,
          y: cords.y,
          color,
          startTick: destroyTick,
          durationTicks: explosionDurationTicks,
          baseRadius,
          scale: 0.5,
          opacity: 0.5,
        };
      }

      const elapsedTicks = isInExplosionWindow ? currentTick - existingExplosion.startTick : 0;
      const progress = Math.min(1, Math.max(0, elapsedTicks / explosionDurationTicks));
      const scale = Math.sin(progress * Math.PI + 1.5);

      activeExplosions.push({
        ...existingExplosion,
        scale: Math.max(0.5, scale),
        opacity: 0.5 * (1 - progress),
      });
    }
  });

  return activeExplosions;
}
